<template>
  <section
    v-if="data"
    class="w-full overflow-hidden"
    :class="spacingClass"
    
  >
    <div :class="data?.containerFull ? 'w-full px-5 lg:px-0' : 'container'">
      <UiHeading
        v-if="data?.heading"
        :pin="data?.heading?.pin"
        :title="data?.heading?.title"
        :description="data?.heading?.description"
        :button="data?.heading?.button"
        color="black"
        :position="data?.heading?.position"
        v-aos="animate && 'zoom-out'"
      />

      <div
        class="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6 xl:gap-10 lg:grid-flow-col-dense"
      >
        <div
          v-aos="animate && aboutAnimation('media')"
          class="w-full"
          :class="mediaOrderClass"
        >
          <div class="grid grid-cols-2 gap-3 xl:gap-4">
            <div class="w-full">
              <AtomsImage
                v-if="data?.media[0]?.mime?.includes('image')"
                class="w-full h-56 xl:h-72 object-cover object-center rounded-2xl"
                :media="data?.media[0]"
                sizeHint="quarter"
                :alt="data?.media[0]?.alternativeText ?? data?.title ?? data?.media[0]?.hash ?? data?.media[0]?.name ?? ''"
              />
            </div>
            <div class="w-full flex items-end">
              <AtomsImage
                v-if="data?.media[1]?.mime?.includes('image')"
                class="w-full h-48 xl:h-64 object-cover object-center rounded-2xl"
                :media="data?.media[1]"
                sizeHint="quarter"
                :alt="data?.media[1]?.alternativeText ?? data?.title ?? data?.media[1]?.hash ?? data?.media[1]?.name ?? ''"
              />
            </div>
            <div class="w-full flex items-start">
              <AtomsImage
                v-if="data?.media[2]?.mime?.includes('image')"
                class="w-full h-48 xl:h-64 object-cover object-center rounded-2xl"
                :media="data?.media[2]"
                sizeHint="quarter"
                :alt="data?.media[2]?.alternativeText ?? data?.title ?? data?.media[2]?.hash ?? data?.media[2]?.name ?? ''"
              />
            </div>
            <div class="w-full">
              <AtomsImage
                v-if="data?.media[3]?.mime?.includes('image')"
                class="w-full h-56 xl:h-72 object-cover object-center rounded-2xl"
                :media="data?.media[3]"
                sizeHint="quarter"
                :alt="data?.media[3]?.alternativeText ?? data?.title ?? data?.media[3]?.hash ?? data?.media[3]?.name ?? ''"
              />
            </div>
          </div>
        </div>
        <div
          v-aos="animate && aboutAnimation('content')"
          class="lg:py-4 xl:py-6 lg:px-6 xl:px-10 flex flex-col justify-center"
          :class="contentOrderClass"
        >
          <div
            v-if="data?.pin"
            class="text-brand-first mb-1 md:mb-2 font-semibold text-base md:text-lg"
          >
            {{ data?.pin }}
          </div>
          <div
            v-if="data?.title"
            class="text-black font-semibold text-3xl md:text-4xl lg:text-[40px] leading-tight"
          >
            {{ data?.title }}
          </div>
          <div
            v-if="data?.description"
            class="text-gray-800 mt-4 md:mt-5 rich-text text-[15px] md:text-base leading-relaxed"
            v-html="data?.description"
          ></div>
          <ul v-if="data?.features?.length" class="mt-8 lg:mt-10 flex flex-col gap-[14px]">
            <template v-for="(item, index) in data?.features" :key="index">
              <li
                class="flex items-start gap-3 w-full text-gray-900"
                v-if="item?.enabled"
              >
                <div class="mt-[8px] w-1.5 h-1.5 rounded-full bg-black shrink-0"></div>
                <span class="text-[15px] font-medium">{{ item.text }}</span>
              </li>
            </template>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from "vue";
import { useIsMobile768 } from "~/composables/utils";
import { useSiteSettingsStore } from "@/store/index";
import { sectionOuterSpacingClass } from "~/composables/sectionSpacing";

const props = defineProps({
  data: {
    type: Object,
  },
  animate: { type: Boolean, default: false },
});

const { isMobile768 } = useIsMobile768();
const siteSettingsStore = useSiteSettingsStore();

const spacingClass = computed(() => sectionOuterSpacingClass(props.data?.spacing));

const contentOrderClass = computed(() => props.data?.position === 'right' ? 'order-2 lg:order-1' : 'order-2 lg:order-2');
const mediaOrderClass = computed(() => props.data?.position === 'right' ? 'order-1 lg:order-2' : 'order-1 lg:order-1');

const aboutAnimation = (side) => {
  if (isMobile768.value) return "fade-up";
  const isRight = props.data?.position === "right";
  if (side === "media") {
    return isRight ? "slide-left" : "slide-right";
  }
  return isRight ? "slide-right" : "slide-left";
};
</script>
